import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  ErrorMessages,
  SuccessMessages,
} from "src/app/shared/constants/utility.constants";
import { ImportModel } from "src/app/shared/models/import";
import { ImportReportModel } from "src/app/shared/models/import-report";
import { School } from "src/app/shared/models/school";
import { ApiDataService } from "src/app/shared/services/api.service";
import { StudentUtility } from "../services/student-utility-services";

@Component({
    selector: "app-import-scores",
    templateUrl: "./import-scores.component.html",
    standalone: false
})
export class ImportScoresComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject <void>();
  dialogDataInstance: any;
  importPhase = 1;
  importScoresForm: UntypedFormGroup;
  importScoreModal: ImportModel = {};
  loading: boolean;
  IsFile: boolean = false;
  schoolList: School[];
  schoolOptions: School[];
  schoolControl: UntypedFormControl = new UntypedFormControl();
  successReport: ImportReportModel;
  fileName: string;
  importSuccessful: boolean;
  scoreDetails: any;
  constructor(
    public dialogRef: MatDialogRef<ImportScoresComponent>,
    private apiService: ApiDataService,
    private toastrService: ToastrService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.importScoresForm = new UntypedFormGroup({
      fileInput: new UntypedFormControl(""),
      school: new UntypedFormControl(""),
    });
    this.getSchools();
    this.schoolControl.valueChanges.subscribe((value) => {
      this.schoolOptions = StudentUtility.filterOptions(
        this.schoolList,
        value,
        ["school_name"]
      );
    });
  }
  getSchools() {
    this.loading = true;
    this.apiService
      .getSchoolList()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.schoolList = res;
          this.schoolOptions = res;
          this.schoolList = res
            .filter((sch) => sch.school_name.replace(/\s/g, "") !== "")
            .sort((a, b) => {
              return a.school_name.localeCompare(b.school_name);
            });
        }
        this.loading = false;
      });
  }

  uploadImage(image: string) {
    document.getElementById(image).click();
  }

  onUpload(event) {
    const file = event.target.files[0];
    this.importScoreModal.file = file;
    this.fileName = file.name;
    if (this.importScoreModal.file) {
      this.IsFile = true;
    } else {
      this.IsFile = false;
    }
  }

  schoolSelected(event) {
    this.importScoreModal.school = event.value;
  }

  resetForm() {
    this.importScoreModal = { file: null, school: null };
    this.fileName = "";
    this.importPhase = 1;
  }

  importScores() {
    this.loading = true;

    this.apiService
      .importScores(this.importScoreModal)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res) => {
          if (res) {
            this.successReport = res;
            this.importSuccessful = true;
            this.importPhase = 2;
            this.scoreDetails =
              this.successReport.imported.length ||
              this.successReport.failed.length ||
              this.successReport.updated.length;
            this.toastrService.success(SuccessMessages.IMPORT_SCORES);
          } else {
            this.importError();
          }
          this.loading = false;
        },
        (error) => {
          const backendMessage =
          error?.error?.ResponseMessage ||
          error?.error?.statusMessage ||
          error?.message ||
          ErrorMessages.IMPORT_SCORES;

        // Special case: Student not found
        if (backendMessage === ErrorMessages.STUDENT_NOT_FOUND) {
          this.errorNotFound();
        }

        // ALWAYS show backend message in toaster
        this.toastrService.error(backendMessage);

        this.loading = false;
        this.importPhase = 2;
        this.importSuccessful = false;
        }
      );
  }

  importError() {
    this.importPhase = 2;
    this.importSuccessful = false;
    this.toastrService.error(ErrorMessages.IMPORT_SCORES);
    this.loading = false;
  }

  errorNotFound() {
    this.loading = false;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }
}
